'use strict';

var slicedToArray = require('../../../node_modules/@babel/runtime/helpers/slicedToArray.js');
var React = require('react');
var useTheme = require('../../Styles/useTheme.js');
var constants = require('./constants.js');
var useMediaQuery = require('../../../node_modules/@material-ui/core/esm/useMediaQuery/useMediaQuery.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

var GlobalRightRailStyles = function GlobalRightRailStyles(_ref) {
  var isOpened = _ref.isOpened;
  var theme = useTheme();
  var isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  var _useState = React.useState(0),
      _useState2 = slicedToArray(_useState, 2),
      transitionTime = _useState2[0],
      setTransitionTime = _useState2[1];

  var _useState3 = React.useState(0),
      _useState4 = slicedToArray(_useState3, 2),
      rightRailWidth = _useState4[0],
      setRrWidth = _useState4[1];

  React.useEffect(function () {
    var width = isMobile || !isOpened ? constants.RIGHT_RAIL_CLOSED_WIDTH : constants.RIGHT_RAIL_OPENED_WIDTH;
    var newTransitionTime = isOpened ? theme.transitions.duration.enteringScreen : theme.transitions.duration.leavingScreen;
    setTransitionTime(newTransitionTime);
    setRrWidth(width);
    var timeout = setTimeout(function () {
      setTransitionTime(0);
    }, newTransitionTime);
    return function () {
      clearTimeout(timeout);
    };
  }, [isOpened, isMobile, theme.transitions.duration.enteringScreen, theme.transitions.duration.leavingScreen]);
  return React__default["default"].createElement("style", {
    dangerouslySetInnerHTML: {
      __html: "\n    @property ".concat(constants.RightRailCssVars.rightRailWidth, " {\n      syntax: '<number>';\n      inherits: true;\n      initial-value: ").concat(rightRailWidth, "px;\n    }\n\n    :root {\n      ").concat(constants.RightRailCssVars.rightRailWidth, ": ").concat(rightRailWidth, "px;\n      ").concat(constants.RightRailCssVars.rightRailTransitionEasing, ": ").concat(theme.transitions.easing.sharp, ";\n      ").concat(constants.RightRailCssVars.rightRailTransitionDuration, ": ").concat(transitionTime, "ms;\n      ").concat(constants.RightRailCssVars.rightRailTransitionDelay, ": 0ms;\n    }\n\n    body {\n      ").concat(isMobile && isOpened ? 'overflow: hidden;' : '', "\n    }\n")
    }
  });
};

module.exports = GlobalRightRailStyles;
